import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Modal } from 'semantic-ui-react';
import UserModalContent from './UserModalContent';

class ModalUser extends Component {

  render() {
    const { userId, trigger, name, groups } = this.props
    return (
      <Modal trigger={trigger} closeIcon>
        <Modal.Header>View Detail</Modal.Header>
        <Modal.Content>
          <UserModalContent userId={userId} name={name} groups={groups}/>
        </Modal.Content>
        <Modal.Actions>
          <Link className="ui positive button" to={`verification-edit/${userId}`}>Verification</Link>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default ModalUser;



// WEBPACK FOOTER //
// ./src/app/component/Datauser/ModalUser.js